module.exports = __webpack_public_path__ + "static/media/dcubusinessschool.8ccce5e8.png";